// Parse a DXF File object and return parsed data for DxfViewer
export async function parseDxfFile(file) {
  const text = await file.text();
  const DxfParser = (await import('dxf-parser')).default;
  const parser = new DxfParser();
  return parser.parseSync(text);
}
